import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "sidebar-status-bar no-print" };
const _hoisted_2 = {
    class: "sidebar-user",
    ref: "user"
};
const _hoisted_3 = ["title", "aria-expanded"];
const _hoisted_4 = {
    class: "sidebar-user-initials",
    "aria-hidden": "true"
};
const _hoisted_5 = { class: "sidebar-user-name" };
const _hoisted_6 = {
    key: 0,
    class: "sidebar-user-menu"
};
const _hoisted_7 = { class: "sidebar-status-icons" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_BackgroundTasksIndicator = _resolveComponent("BackgroundTasksIndicator");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" Who is signed in "),
        _cache[10] || (_cache[10] = _createTextVNode()),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
                type: "button",
                class: "sidebar-user-button",
                title: _ctx.displayName,
                "aria-expanded": _ctx.userMenuOpen,
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.userMenuOpen = !_ctx.userMenuOpen))
            }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.initials), 1 /* TEXT */),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.displayName), 1 /* TEXT */),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa fa-angle-down sidebar-user-caret" }, null, -1 /* CACHED */))
            ], 8 /* PROPS */, _hoisted_3),
            _cache[9] || (_cache[9] = _createTextVNode()),
            (_ctx.userMenuOpen)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                    _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                            to: { name: _ctx.routes.MyProfile },
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.userMenuOpen = false))
                        }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                    _createElementVNode("i", { class: "fa fa-fw fa-user" }, null, -1 /* CACHED */),
                                    _createTextVNode(" My Profile\r\n\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"])
                    ]),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                            to: { name: _ctx.routes.Logout },
                            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.userMenuOpen = false))
                        }, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                    _createElementVNode("i", { class: "fa fa-fw fa-power-off" }, null, -1 /* CACHED */),
                                    _createTextVNode(" Sign Out\r\n\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"])
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ], 512 /* NEED_PATCH */),
        _cache[11] || (_cache[11] = _createTextVNode()),
        _createCommentVNode(" Status icons. The notifications bell will go here too. "),
        _cache[12] || (_cache[12] = _createTextVNode()),
        _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_BackgroundTasksIndicator)
        ])
    ]));
}
